export default __webpack_public_path__ + "static/media/second_section.891f69eb.png";